import { takeEvery } from 'redux-saga/effects';

import { USER_SETTINGS_MODAL, UserSettingsModalAction } from 'js/actionCreators/userSettingsActions';

import { track } from '../mixpanelProvider';

function* trackUserSettingsModal(action: UserSettingsModalAction) {
  if (action.isOpen) {
    yield track('Open Default Settings Modal');
  }
}

export default function* trackUserSettings() {
  yield takeEvery(USER_SETTINGS_MODAL, trackUserSettingsModal);
}
